<template>
  <logout-icon role="button" class="logout-icon" @click.prevent="logout" />
</template>

<script lang="ts" setup>
import LogoutIcon from '@images/logout.svg?component';
import { useRouter } from 'vue-router';
import { setAuthToken } from '@/utils/tokenManager';
import { useStore } from '@/store';

const store = useStore();
const router = useRouter();

const logout = () => {
  setAuthToken('');
  router.push({ name: 'login' });
  store.commit('auth/SET_USER', null);
};
</script>

<style lang="scss" scoped>
.logout-icon {
  @apply text-inactive cursor-pointer;
  height: px(25);

  :deep(path) {
    stroke: currentColor;
  }
}
</style>
